// React
import * as React from 'react';

//Redux
import { connect } from 'react-redux';

// Router
import { NavLink } from 'react-router-dom';

// MainStore
import { MainStore } from '../stores/MainStore';

// Components
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CollectionsIcon from '@material-ui/icons/Collections';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import ShortTextIcon from '@material-ui/icons/ShortText';
import PetsIcon from '@material-ui/icons/Pets';
import PersonIcon from '@material-ui/icons/Person';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

// Functions
import {getURLByEnv} from '../framework/utils/URL';
import { NetworkManager } from '../managers/NetworkManager';

/**
 * @description Props Interface
 * @author Lucas Fridez <lucas@fridez.dev>
 * @interface Props
 */
interface Props {
    navigation: any;
    user: any;
}

/**
 * @description Contain the props of a Menu Child
 * @author Lucas Fridez <lucas@fridez.dev>
 * @interface Menu
 */
interface Menu {
    icon: any;
    link: string;
    title: string;
}

/**
 * @description Contain all the menus
 * @author Lucas Fridez <lucas@fridez.dev>
 */
const menus: Array<Menu> = [
    {
        icon: <DashboardIcon />,
        link: `${getURLByEnv()}/`,
        title: "Accueil"
    },
    {
        icon: <ShortTextIcon />,
        link: `${getURLByEnv()}/Articles`,
        title: "Articles"
    },
    {
        icon: <PetsIcon />,
        link: `${getURLByEnv()}/Animaux`,
        title: "Animaux"
    },
    {
        icon: <PetsIcon />,
        link: `${getURLByEnv()}/Races`,
        title: "Races"
    },
    {
        icon: <PersonIcon />,
        link: `${getURLByEnv()}/Eleveurs`,
        title: "Eleveurs"
    },
    {
        icon: <PersonPinIcon />,
        link: `${getURLByEnv()}/RendezVous`,
        title: "Rendez-vous"
    },
    {
        icon: <FormatListNumberedIcon />,
        link: `${getURLByEnv()}/Resultats`,
        title: "Résultats"
    },
    {
        icon: <SupervisorAccountIcon />,
        link: `${getURLByEnv()}/Comite`,
        title: "Comité"
    },
    {
        icon: <CollectionsIcon />,
        link: `${getURLByEnv()}/Galeries`,
        title: "Galerie"
    },
    {
        icon: <InsertDriveFileIcon />,
        link: `${getURLByEnv()}/Conseils`,
        title: "Conseils"
    },
    {
        icon: <ShortTextIcon />,
        link: `${getURLByEnv()}/Textes`,
        title: "Textes"
    },
    {
        icon: <CollectionsIcon />,
        link: `${getURLByEnv()}/Colonie`,
        title: "Colonie"
    }
];

/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * @description Navigation Component
 */
export default connect((state) => state)(class Navigation extends React.Component<Props, {}> {

    /**
     * Creates an instance of Navigation.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     */
    constructor(props: any) {
        super(props);
    }

    componentWillMount() {
        if (NetworkManager.getUserCredentials() !== undefined) {
            NetworkManager.connect();
        }
    }

    isSubMenuInMenu(menu: string, subMenu: string) {
        if (menu == `${getURLByEnv()}/`) {
            return subMenu == `${getURLByEnv()}/` ? true : false;
        }
        return subMenu.includes(menu.slice(1));
    }

    /**
     * @description Render the Navigation Component
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     */
    render() {
        return (
            <Drawer
                variant="persistent"
                anchor="left"
                open={this.props.navigation.navigation}
                className={this.props.navigation.navigation ? 'drawer-open' : 'drawer-closed'}>
                <div className="drawerHeader">
                    <IconButton onClick={MainStore.toggleNavigation(this.props.navigation.navigation)}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <List component="nav">
                    {menus.map((value: Menu, index) => {
                        return (
                            <NavLink exact={value.title == "Accueil"} to={value.link} activeClassName="menu-active"
                            onClick={MainStore.updateActualView(value.link)} key={index}>
                                <ListItem button={true}>
                                    <ListItemIcon>
                                        {value.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={value.title} />
                                </ListItem>
                            </NavLink>
                        );
                    })}
                </List>
            </Drawer>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/components/Navigation.tsx